<template>
    <div class="card">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="pt-3 row">
                <div class="col-2"></div>
                <div class="col-8 d-flex flex-row justify-content-center">
                    <h5 class="card-title">
                        {{ this.t('HOME.RESUM_ASSIGN') }}
                    </h5>
                </div>
                <div class="col-2">
                    <label>Documentos:</label>
                    <select2 :settings="{width: '100%'}"
                             :options="[
                                        {id:'aditivos', text: 'Aditivos'},
                                        {id:'contract', text: 'Contratos'},
                                        {id:'construcoes', text: 'Construções'},
                                        {id:'escrituras', text: 'Escrituras'},
                                        {id:'business_proposal', text: 'Propostas'},
                                        {id:'quitacoes', text: 'Quitações'},
                                        {id:'rescisoes', text: 'Rescisões'},
                                        {id:'renegociacoes', text: 'Renegociações'},
                                        {id:'renegociacao_de_parcelas', text: 'Renegociações de Parcelas'},
                                        {id:'all', text: 'Todos'},
                                        {id:'transferencias', text: 'Transferências'},
                                        {id:'troca_de_lotes', text: 'Troca de Lotes'},
                             ]" v-model="typeGrafic" @select="$emit('changeTypeDoc', $event)"
                             placeholder="Todos"
                    ></select2>
                </div>
                <div class="main-container col-12" :class="loadChart ? 'filterBlur' : ''"
                     style="height: 40vh">
                    <slot name="graficPlot"></slot>
                </div>
            </div>
        </div>
        <div class=" col-12 d-flex justify-content-center w-100 pb-3">
            <slot name="buttonsAlterDay"></slot>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import {mapState} from 'vuex';
import Select2 from 'vue3-select2-component';

export default {
    name: "cardGraficResumAssingComponent",
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    components:{
        Select2,
    },
    data() {
        return{
            typeGrafic: 'all',
        }
    },
    computed: {
        ...mapState({
            loadChart: (state) => state.home.loadChart
        })
    }
}
</script>

<style scoped>
.filterBlur {
    filter: blur(5px)
}
</style>